<mat-checkbox class="mat-mdc-option" [indeterminate]="isIndeterminate()" 
    [checked]="isChecked()" (click)="$event.stopPropagation()"
    (change)="toggleSelection($event)">
    {{'All'}}
</mat-checkbox>
